import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const SystemTranslationKeys = {
  id403ExpectedManager: translationKey('errorPage_403_expectedManager'),
  id403InsufficientPermissions: translationKey('errorPage_403_insufficientPermissions'),
  id403NotFound: translationKey('errorPage_403_notFound'),
  id403PageNotFoundExtended: translationKey('errorPage_403_pageNotFoundExtended'),
  id409ConflictVersionMismatch: translationKey('errorPage_409_conflictVersionMismatch'),
  id409ConflictVersionMismatchExtended: translationKey('errorPage_409_conflictVersionMismatchExtended'),
  unexpectedError: translationKey('errorPage_unexpectedError'),
  unexpectedErrorExtended: translationKey('errorPage_unexpectedError_extended'),
  descriptionWeb: translationKey('feedback_description_web'),
  finalMessage: translationKey('feedback_final_message'),
  hint: translationKey('feedback_hint'),
  label: translationKey('feedback_label'),
  title: translationKey('feedback_title'),
  gdprClauseErrorTitle: translationKey('gdpr_clause_error_title'),
  gdprClauseLinkText: translationKey('gdpr_clause_link_text'),
  gdprClauseUnavailable: translationKey('gdpr_clause_unavailable'),
} as const satisfies Record<string, TranslationKey>;
